/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';

import {AppSharedModule} from '../common/app-shared.module';
import {PaymentRoutePageComponent} from './payment-route-page.component';
import {PaymentListPageComponent} from './payment-list-page.component';
import {PaymentStatusLabelComponent} from './payment-status-component';

@NgModule({
  imports: [AppSharedModule, UIRouterModule],
  declarations: [
    PaymentRoutePageComponent,
    PaymentListPageComponent,
    PaymentStatusLabelComponent
  ],
  // Only the status label is used outside this feature (campaign / review).
  exports: [PaymentStatusLabelComponent]
})
export class PaymentModule {
}
